(function($){
    "use strict";

    $.fn.categorytabs = function () {

        $(this).each(function () {

            // Remove any elements that shouldn't show when active
            $(this).find('[data-category-tab-hide]').hide();

            // Find the closest tab navigation and add active to first
            $(this).find('[data-category-tab-navigation] a:first-child').addClass('is-active');

            // Hide all tab contents except first
            $(this).find('[data-category-tab-content] > *:not(:first-child)').hide();

            // Setup on click handler for tabs
            $(this).find('[data-category-tab-navigation] > *').on('click', function (e) {
                e.preventDefault();

                // Get the ID of this tabs target
                var target = $(this).data('link');

                // Remove active from all tabs and add to this one
                $(this).siblings().removeClass('is-active');
                $(this).addClass('is-active');

                // Hide all tab contents and show this one
                $(this).closest('[data-category-tabs]').find('[data-category-tab-content] > *').hide();
                $(this).closest('[data-category-tabs]').find('[data-category-tab-content] [data-category-content="' + target + '"]').show();
            });
        });

        // Return the jQuery element
        return this;
    };

})(jQuery);
